import { render, staticRenderFns } from "./column.vue?vue&type=template&id=1f59ae77&scoped=true&"
import script from "./column.vue?vue&type=script&lang=js&"
export * from "./column.vue?vue&type=script&lang=js&"
import style0 from "./column.vue?vue&type=style&index=0&id=1f59ae77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59ae77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f59ae77')) {
      api.createRecord('1f59ae77', component.options)
    } else {
      api.reload('1f59ae77', component.options)
    }
    module.hot.accept("./column.vue?vue&type=template&id=1f59ae77&scoped=true&", function () {
      api.rerender('1f59ae77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/table-columns/form/column.vue"
export default component.exports